/**
 * Normalize spaces around characters
 * @param {String} input
 * @returns {String}
 */
const normalizeCharacterSpaces = (input) => {
  let result = input;

  if (result.includes("[")) {
    result = result.replace(/\s*\[\s*/g, "[");
  }

  if (result.includes("]")) {
    result = result.replace(/\s*\]\s*/g, "]");

    if (result.includes("][")) {
      result = result.replace(/\]\[/g, "],[");
    }
  }

  if (result.includes("(")) {
    result = result.replace(/\(\s*/g, "(");
  }

  if (result.includes(")")) {
    result = result.replace(/\s*\)/g, ")");
  }

  if (result.includes("%:[")) {
    result = result.replace(/%:\[/g, "%_[");
  }

  if (result.includes("%[")) {
    result = result.replace(/%\[/g, "%_[");
  }

  if (result.includes("s[")) {
    result = result.replace(/(\d)(ms|s)\[/g, "$1$2_[");
  }

  if (result.includes(") )")) {
    result = result.replace(/\) \)/g, "))");
  }

  if (result.includes("⌣")) {
    result = result.replace(/⌣/g, " ");
  }

  if (result.includes("<")) {
    result = result.replace(/\s*\<\s*/g, "<");

    if (result.includes("],<")) {
      result = result.replace(/\],</g, "]<");
    }
  }

  if (result.includes(">")) {
    result = result.replace(/\s*\>\s*|,>/g, ">");
  }

  if (result.includes("|")) {
    result = result.replace(/\s*\|\s*/g, "_-_");
  }

  if (result.includes("from:[")) {
    result = result.replace(/\[from\:\[/g, "[0%_[");
  }

  if (result.includes("to:[")) {
    result = result.replace(/(?!(,|\[))to\:\[/g, "100%_[");
  }

  if (result.includes("`")) {
    result = result
      .replace(/`(.*?)`/g, (item) => item.replace(/,/g, "¦"))
      .replace(/`/g, "");
  }

  return result;
};

export default normalizeCharacterSpaces;
